export enum HtmlExpressionType {
    Directive = 0,
    Sequence = 1,
    Text = 2
}